import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/lib/api-client'

export interface HouseholdMember {
  id: string
  userId: string
  displayName: string | null
  email: string
  role: 'Planner' | 'Member'
  joinedAt: string
}

export function useHouseholdMembers() {
  return useQuery({
    queryKey: ['household', 'members'],
    queryFn: () => apiClient.get<HouseholdMember[]>('/api/v1/households/members'),
  })
}
